import React from 'react';

const Home = (): JSX.Element => {
  return (
    <iframe
      src="https://batch-crane-67740236.figma.site"
      width="100%"
      height="100%"
      style={{ border: 'none', minHeight: '100vh' }}
    />
  );
};

export default Home;
